<template>
  <div
    v-if="props?.icons?.length"
    class="pdp-contact"
  >
    <div
      v-if="props?.description"
      class="pdp-contact__content content"
    >
      {{ props?.description }}
    </div>

    <ul class="pdp-contact__list">
      <li
        v-for="item in props?.icons"
        :key="item"
        class="pdp-contact__item"
      >
        <component
          :is="getElement(item.Link)"
          class="pdp-contact__button button--link button"
          :to="item.Link"
        >
          <component
            :is="loadIcon(item.Icon)"
            class="pdp-contact__icon icon"
          />
          <span>
            {{ item.Name }}
          </span>
        </component>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
// import layoutQuery from '~layers/app/graphql/layout.gql'

import {
  AppLink,
} from '#components'

const props = withDefaults(defineProps<{
  title?: string
  description?: string
  icons: Array<{ Name: string, Link: string, Icon: string }>
}>(), {
  title: '',
  description: '',
})

function getElement(to: any) {
  return to ? AppLink : 'span'
}

const { loadIcon } = useStrapiIcons()
</script>

<style>
@import url("~layers/app/components/Product/Contact.css");
</style>
